var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSunFull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prefIcon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.69 18.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Full sun - ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_113",
    "data-name": "Ellipse 113",
    className: "cls-1",
    cx: 9.34,
    cy: 9.41,
    r: 4.48
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    className: "cls-1",
    d: "M13.82,5.33a.4.4,0,0,1-.39-.4.43.43,0,0,1,.11-.28l1.84-1.83a.39.39,0,1,1,.57.54h0L14.1,5.21A.4.4,0,0,1,13.82,5.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    className: "cls-1",
    d: "M18.27,9.8h-2.6a.38.38,0,0,1-.41-.37A.39.39,0,0,1,15.64,9h2.63a.39.39,0,1,1,0,.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    className: "cls-1",
    d: "M15.66,16.12a.39.39,0,0,1-.28-.12l-1.84-1.83a.4.4,0,0,1,0-.56.4.4,0,0,1,.56,0v0l1.84,1.84a.39.39,0,0,1,0,.55A.36.36,0,0,1,15.66,16.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    className: "cls-1",
    d: "M9.35,18.73a.39.39,0,0,1-.4-.39H9v-2.6a.4.4,0,0,1,.79,0v2.64A.39.39,0,0,1,9.35,18.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    className: "cls-1",
    d: "M9.35,3.37A.4.4,0,0,1,9,3H9V.37A.4.4,0,0,1,9.37,0a.39.39,0,0,1,.37.37V3A.4.4,0,0,1,9.35,3.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    className: "cls-1",
    d: "M3,16.12a.4.4,0,0,1-.28-.67l1.84-1.84a.4.4,0,0,1,.56,0,.41.41,0,0,1,0,.55L3.31,16A.36.36,0,0,1,3,16.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    className: "cls-1",
    d: "M3,9.8H.41A.38.38,0,0,1,0,9.43.39.39,0,0,1,.37,9H3a.39.39,0,1,1,0,.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    className: "cls-1",
    d: "M4.87,5.33a.4.4,0,0,1-.28-.12L2.75,3.37a.39.39,0,0,1,.54-.57l0,0L5.15,4.65a.4.4,0,0,1,0,.56A.44.44,0,0,1,4.87,5.33Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunFull);
export default __webpack_public_path__ + "static/media/sun-full.fec7a41be18ee20ab0467fe3fbe4d579.svg";
export { ForwardRef as ReactComponent };